import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import refreshable from 'common/refreshable';
import { createFetchPageAction, refreshBuckets } from 'common/page/actions';
import Drawer from 'webapp/drawer/Drawer';
import HeroPlaybackPageContainer from 'webapp/page/hero/HeroPlaybackPageContainer';

const Player = ({ location = {}, isMobile }) => {
    // if the player was routed to with an alert, pass it on down
    const { alertContent, placement, bucketId, bucketName, pageId, pageName, userInitiated } = location.state || {};

    // Some styles of the playback page depend on a 'no-touch' parent class.  This assumed
    const mobileClass = (isMobile === false ? 'no-touch' : '');
    return (
        <section id="playback" className={mobileClass}>
            <HeroPlaybackPageContainer
                alertContent={alertContent}
                location={location}
                placement={placement}
                bucketId={bucketId}
                bucketName={bucketName}
                pageId={pageId}
                pageName={pageName}
                userInitiated={userInitiated}
            />
            <Drawer />
        </section>
    );
};

Player.propTypes = {
    isMobile: PropTypes.bool,
    location: PropTypes.object
};

Player.loadActions = [
    (pathParams, query, lang) => createFetchPageAction('player', pathParams, query, lang)
];

Player.refreshInterval = 300; // 5 mins
Player.onRefresh = ({ dispatch }) => {
    dispatch(refreshBuckets('player'));
};

const mapStateToProps = (state) => ({
    isMobile: state.app.isMobile || false
});

export default connect(mapStateToProps)(refreshable(Player));



// WEBPACK FOOTER //
// ./app/webapp/page/Player.js